import React from "react";

const Base = ({ children }) => {
  return (
    <div className=" min-h-screen w-full px-4 py-2 bg-gray-100">
      <div className="bg-white  w-full shadow-secondaryShadow rounded-2xl full-height">
        {children}
      </div>
    </div>
  );
};

export default Base;
